module.exports = __webpack_public_path__ + "img/Eggmoney_KR.c2ab0b42.png";